import { NgModule } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { ProductsArrayApiRepository } from './infrastructure/api/productsArray-api.repository';
import { ProductsArrayQueriesFacade } from './infrastructure/facades/queries/productsArray.queries.facades';
import { ProductsArraySharedQueriesFacade } from './infrastructure/facades/queries/shared-queries.facades';
import { ProductsArrayPublicPort } from './infrastructure/public/public.port';
import { ProductsArrayEffects } from './infrastructure/state/productsArray.effects';
import { ProductsArrayReducer } from './infrastructure/state/productsArray.reducer';

@NgModule({
    providers: [
        provideState({ name: 'productsArray', reducer: ProductsArrayReducer }),
        provideEffects(ProductsArrayEffects),
        ProductsArrayApiRepository,
        ProductsArrayPublicPort,
        ProductsArrayQueriesFacade,
        ProductsArraySharedQueriesFacade,
    ],
})

/**
 * Módulo de la feature de ProductsArray
 */
export class ProductsArrayFeatureCoreModule {}
